import initialState from 'reducers/initialState';
import * as types from 'features/document/edit/documents/actionTypes';
import { OFFER_PARTNER_UPDATED } from 'features/offer/edit/client/form/eventTypes';
import { OFFER_ASSET_CLIENT_UPDATED, OFFER_ASSET_CLIENT_INVALIDATED } from 'features/offer/edit/assets/client/eventTypes';
import { ASSOCIATED_PARTNERS_INVALIDATED } from 'features/offer/edit/client/form/eventTypes';
import { DOCUMENT_PARTNERS_INVALIDATED } from 'features/offer/edit/client/form/eventTypes';

const guarantorsReducer = (state = initialState.document.guarantors, action) => {
  switch (action.type) {
    case types.LOAD_GUARANTORS_STARTED: {
      let { key } = action;
      let result = { ...state };
      result = {
        ...state,
        [key]: {
          ...state[key],
          loading: true,
          loaded: false
        }
      };
      return result;
    }

    case types.LOAD_GUARANTORS_SUCCEEDED: {
      let { key } = action;
      let result = { ...state };

      result = {
        ...state,
        [key]: {
          ...state[key],
          loading: false,
          loaded: true
        }
      };
      return result;
    }

    case DOCUMENT_PARTNERS_INVALIDATED: {
      return initialState.document.guarantors;
    }

    case OFFER_PARTNER_UPDATED: {
      return initialState.document.guarantors;
    }

    case OFFER_ASSET_CLIENT_UPDATED: {
      return initialState.document.guarantors;
    }

    case OFFER_ASSET_CLIENT_INVALIDATED: {
      return initialState.document.guarantors;
    }

    case ASSOCIATED_PARTNERS_INVALIDATED: {
      return initialState.document.guarantors;
    }

    default:
      return state;
  }
};

export default guarantorsReducer;
